import React from "react";
import "./Projects.css";
import ProjectBtn from "../components/ProjectBtn";
import ProjectBtnCode from "../components/ProjectBtnCode";

import {
  DiReact,
  DiJavascript1,
  DiHtml5,
  DiCss3,
  DiBootstrap,
  DiNodejs,
  DiNodejsSmall,
  DiMongodb,
} from "react-icons/di";
import { SiFirebase } from "react-icons/si";
import { AiFillCaretRight } from "react-icons/ai";

import { WorksTitle } from "../components/TitleSection";

function Projects() {
  return (
    <div className="project-container" id="projects">
      <div className="project-wrap">
        <WorksTitle />
        {/*Project1*/}
        <div className="projects">
          <div className="project-div-vid proj1">
            <video
              src="coolzonevid.mp4"
              loop
              autoPlay
              muted
              className="projectvid"
              id="coolzonevid"
              width="80%"
            />
          </div>

          <div className="project-div-desc proj1">
            <div className="project-name">Coolzone</div>

            <div className="tech-list">
              <span id="react">
                <DiReact />
              </span>
              <span id="js">
                <DiJavascript1 />
              </span>
              <span id="node">
                <DiNodejsSmall />
              </span>
              <span id="ex">
                <span>ex</span>
              </span>
              <span id="mongo">
                <DiMongodb />
              </span>
            </div>

            <div className="deploy-demo">
              <a href="/" target="_blank">
                <button className="deploy-btn">View Site</button>
              </a>
              <a href="/" target="_blank">
                <button className="demo-btn">View Code</button>
              </a>
            </div>

            <div className="desc-content">
              <p>
                Built Full stack e-commerce website from scratch using React and
                Redux for frontend.
              </p>
              <p>
                Set up backend API, data import scripts using Node, Express and
                MongoDB.
              </p>
              <p>
                Built fully-functional cart, allowing for addition and removal
                of items, accurately totaling price and quantity.
              </p>
            </div>
          </div>
        </div>

        {/*Project2*/}
        <div className="projects ">
          <div className="project-div-vid proj2">
            <video
              src="trackervid.mp4"
              loop
              autoPlay
              muted
              className="projectvid"
              id="trackervid"
              width="80%"
            />
          </div>

          <div className="project-div-desc proj2">
            <div className="project-name">Recruiter Tracker</div>

            <div className="tech-list">
              <span id="react">
                <DiReact />
              </span>
              <span id="js">
                <DiJavascript1 />
              </span>
              <span id="html">
                <DiHtml5 />
              </span>
              <span id="css">
                <DiCss3 />
              </span>
              <span id="fire">
                <SiFirebase />
              </span>
            </div>

            <div className="deploy-demo">
              <a href="/" target="_blank">
                <button className="deploy-btn">View Site</button>
              </a>
              <a
                href="/"
                target="_blank"
              >
                <button className="demo-btn">View Code</button>
              </a>
            </div>

            <div className="desc-content">
              <p>
                Built CRUD app for a staffing firm to keep track of applicant
                data, login and store data in the realtime database using Google
                Firebase.
              </p>
              <p>
                Featured add, update and delete functionality and persistent
                state management using React hooks.
              </p>
            </div>
          </div>
        </div>

        {/*Project3*/}
        <div className="projects">
          <div className="project-div-vid proj3">
            <video
              src="solovid.mp4"
              loop
              autoPlay
              muted
              className="projectvid"
              id="solovid"
              width="80%"
            />
          </div>

          <div className="project-div-desc proj3">
            <div className="project-name">SoloGameCell</div>

            <div className="tech-list">
              <span id="react">
                <DiReact />
              </span>
              <span id="js">
                <DiJavascript1 />
              </span>
              <span id="html">
                <DiHtml5 />
              </span>
              <span id="css">
                <DiCss3 />
              </span>
            </div>

            <div className="deploy-demo">
              <a href="/" target="_blank">
                <button className="deploy-btn">View Site</button>
              </a>
              <a
                href="/"
                target="_blank"
              >
                <button className="demo-btn">View Code</button>
              </a>
            </div>

            <div className="desc-content">
              <p>
                Design react website for a Game developer client to showcase
                games and apps and link to the google play site.
              </p>
              <p>
                Minimalistic user interface and use React Router for dynamic
                page viewing.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Projects;
